import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../firmwareAssignmentState/firmwareAssignmentContext';
import Firmware from './components/Firmware';
import style from './Firmwares.module.scss';

const Firmwares: React.FC = () => {
	const { firmwareForAssign } = useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	return (
		<div className={style.container} data-test="Firmwares">
			<div className={style.tableOfContents}>
				<Text
					className={style.name}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
				/>
				<Text
					className={style.type}
					translationNameSpace="listing"
					translationKey="firmwareTypeLabel"
					theme="neutralLight"
				/>
			</div>
			{firmwareForAssign.items.map((el) => (
				<Firmware data={el} key={el.id + 'firmwareList'} />
			))}
		</div>
	);
};

export default Firmwares;
